import { NgClass } from '@angular/common';
import {
    Component,
    ContentChild,
    ElementRef,
    ViewEncapsulation,
    AfterContentInit,
    ChangeDetectionStrategy,
} from '@angular/core';

@Component({
    selector: 'app-toggle-password',
    templateUrl: './toggle-password.component.html',
    styleUrls: ['./toggle-password.component.scss'],
    imports: [NgClass],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TogglePasswordComponent implements AfterContentInit {
    @ContentChild('passwordInput') private passwordInput: ElementRef;

    public passwordShown: boolean = true;

    public ngAfterContentInit(): void {
        this.togglePasswordVisibility();
    }
    protected togglePasswordVisibility(): void {
        this.passwordShown = !this.passwordShown;
        this.passwordInput.nativeElement.type = this.passwordShown ? 'text' : 'password';
    }
}
